var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pravo-sirsi"},[_c('Search'),_c('div',{staticClass:"pravo-sirsi__tables"},[_c('GamesTable',{attrs:{"sourceData":_vm.myGames,"type":"my"},on:{"action":_vm.continueGame}}),_c('br'),_c('GamesTable',{attrs:{"sourceData":_vm.allGames,"type":"all"},on:{"action":_vm.joinLobby}}),_c('br')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }